import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useEffect } from "react"
import PageTopTitle from "../shared/PageTopTitle"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-block: 20px;
        border-radius: 10px;
        
        .content{
            padding: 30px 50px;
            .col{
                display: flex;
                flex-direction: column;
                .row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-block: 5px;
                    p{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                    }
                    span{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-sm);
                    }
                }
            }
        }

        .btns{
            display: flex;
            align-items: center;
            margin-top: 25px;
            width: 100%;
            justify-content: center;
            button{
                margin-right: 10px;
                width: auto;
            }
        }
    }

`
    
const UETDSGonderilmisDetayModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const { UETDSItemData } = useSelector(state => state.admin)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle title={"UETDS Gönderilmiş Bildirim"}/>

            <div className="content">
                <div className="col">
                    <div className="row">
                        <p>Taşıma Türü:</p>
                        <span>{UETDSItemData?.tasimaTuruKodu === 2 ? "Normal Yük" : "Tehlikeli Yük"}</span>
                    </div>
                    <div className="row">
                        <p>Plaka:</p>
                        <span>{UETDSItemData?.plaka1}</span> 
                    </div>
                    <div className="row">
                        <p>Y.Römork - Römork Plakası:</p>
                        <span>{UETDSItemData?.plaka2}</span>
                    </div>
                    <div className="row">
                        <p>Sürücü TC No:</p>
                        <span>{UETDSItemData?.user?.tckn}</span>
                    </div>
                    <div className="row">
                        <p>Yükleme Tarihi:</p>
                        <span>{UETDSItemData?.yuklemeTarihi}</span>
                    </div>
                    <div className="row">
                        <p>Yükleme Saati:</p>
                        <span>{UETDSItemData?.yuklemeSaati}</span>
                    </div>
                    <div className="row">
                        <p>Boşaltma Tarihi:</p>
                        <span>{UETDSItemData?.bosaltmaTarihi}</span>
                    </div>
                    <div className="row">
                        <p>Boşaltma Saati:</p>
                        <span>{UETDSItemData?.bosaltmaSaati}</span>
                    </div>
                    <div className="row">
                        <p>Gönderen Adı / Ünvanı:</p>
                        <span>{UETDSItemData?.gondericiUnvan}</span>
                    </div>
                    <div className="row">
                        <p>Gönderen Vergi Numarası:</p>
                        <span>{UETDSItemData?.gondericiVergiNo}</span>
                    </div>
                    <div className="row">
                        <p>Alıcı Adı / Ünvanı:</p>
                        <span>{UETDSItemData?.aliciUnvan}</span>
                    </div>
                    <div className="row">
                        <p>Alıcı Vergi Numarası:</p>
                        <span>{UETDSItemData?.aliciVergiNo}</span>
                    </div>
                    <div className="row">
                        <p>Yükleme İl / İlçe:</p>
                        <span>{UETDSItemData?.yuklemeIlAdi} / {UETDSItemData?.yuklemeIlceAdı}</span>
                    </div>
                    <div className="row">
                        <p>Boşaltma İl / İlçe:</p>
                        <span>{UETDSItemData?.bosaltmaIlAdi} / {UETDSItemData?.bosaltmaIlceAdı}</span>
                    </div>
                    <div className="row">
                        <p>Yükün Türü:</p>
                        <span>{UETDSItemData?.yukCinsAdi}</span>
                    </div>
                    <div className="row">
                        <p>Yükün Birimi:</p>
                        <span>{UETDSItemData?.yukBirimi}</span>
                    </div>
                    {UETDSItemData?.tehlikeliMaddeTasimaTuru &&
                    <>
                        <div className="row">
                            <p>Tehlikeli Madde Taşıma Türü:</p>
                            <span>{UETDSItemData?.tehlikeliMaddeTasimaTuru}</span>
                        </div>
                        <div className="row">
                            <p>UN Kodu:</p>
                            <span>{UETDSItemData?.unId}</span>
                        </div>
                    </>
                    }
                    <div className="row">
                        <p>Yükün Miktarı:</p>
                        <span>{UETDSItemData?.yukMiktarı}</span>
                    </div>
                    <div className="row">
                        <p>Nakliye Bedeli:</p>
                        <span>{UETDSItemData?.tasimaBedeli}</span>
                    </div>
                </div>
            </div>

            <div className="btns">
                <Button width="150px" handleClick={() => dispatch(showModal(null)) } padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
            </div>
            
        </div>
    </Container>
  )
}

export default UETDSGonderilmisDetayModal